import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { LanguageActionsService } from '../store/actions/languages.actions';

export const langResolver: ResolveFn<boolean> = (route) => {
  const _action = inject(LanguageActionsService);

  _action.setLang(route.params['lang']);
  return true;
};
